export const i18Keys = {
  ADD_ABOUT_ELEMENT: 'add-button.label',
  ADD_NEW_ELEMENT_MODAL_TITLE: 'add-new-element-modal.title',
  ADD_NEW_ELEMENT_MODAL_BUTTON: 'add-new-element-modal.button'
};
